export default Object.freeze({
  Query: 'QUERY',
  Mutation: 'MUTATION',
  Subscription: 'SUBSCRIPTION'
});
